import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { apiClient } from "../../../api/client";

// GET /api/v1/plannings/{id}/roster/ → [{ id, student:{id,name}, attendance_status, attendance_id }]
function useRoster(planningId) {
  return useQuery({
    queryKey: ["plannings", planningId, "roster"],
    queryFn: () =>
      apiClient
        .get(`/api/v1/plannings/${planningId}/roster/`)
        .then((r) => r.data),
    enabled: !!planningId,
  });
}

// POST /api/v1/plannings/{id}/add-student/ { student_id | quick_create:{name,...} }
function useAddStudent(planningId) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (data) =>
      apiClient
        .post(`/api/v1/plannings/${planningId}/add-student/`, data)
        .then((r) => r.data),
    onSuccess: () =>
      qc.invalidateQueries({ queryKey: ["plannings", planningId, "roster"] }),
  });
}

export { useRoster, useAddStudent };
